import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Bank } from "../../models/corporation/bank.model";
import {HttpClient} from "@angular/common/http";
import { AppState } from "../../interfaces/app-state.interface";
import { Store } from "@ngrx/store";
import { IApiQueryListResponse } from "../../interfaces/api/api-query-list-response/api-query-list-response.interface";
import { SettingsService } from "../settings/settings.service";
import { BackendService } from "../backend/backend.service";
import { DefaultResponse } from '../../models/form/DefaultResponse';
import { HttpHeaders } from '@angular/common/http';
import { Token } from "../../models/authentication/token.model";

@Injectable({ providedIn: 'root' })
export class BanksService {

  authenticationToken: any;
  public banks: Observable<Array<Bank>>;

  get headers(): HttpHeaders {
    return new HttpHeaders({
        'Content-Type': 'application/json; charset=UTF-8',
        'Authorization': `Bearer ${this.authenticationToken}`,
    });
  }

  constructor(
      private backendService: BackendService,
      private settingsService: SettingsService,
      private store: Store<AppState>
    ) { }

  /** Retorna uma lista de bancos */
  getBanksList() {
    return this.backendService.get<IApiQueryListResponse<Bank>>('corporation/bank');
  }

  create(data: any) {
    return this.backendService.post<DefaultResponse>('v2/users/bank-account/create', data.value, data.token);
  }

  delete(data: any){
    return this.backendService.post<DefaultResponse>('v2/users/bank-account/delete', data.value, data.token);
  }

  update(data: any){
    return this.backendService.put<DefaultResponse>('userprofile/bankaccount', data);
  }

}
